window.$ = window.jQuery = require('jquery');

require('bootstrap/dist/js/bootstrap.min');
require('vgnav/dist/js/vgnav');
require('vgformsender/dist/js/vgformsender');

require('../../vendor/vegas/toScroll/jquery.vegasScrollTo');
window.fbx = require('@fancyapps/ui/dist/fancybox.esm');

require('./functions');

// modules
require('./modules/vegas');
require('./modules/portfolio');
require('./modules/carousel');
require('./modules/ym');
require('./modules/typed');
require('./modules/about');
require('./modules/services');
require('./modules/mask');
require('./modules/brief');

// custom js
require('./custom');
